// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"203":"6f9bb873fbccf070","894":"2e8dde2590aaaed6"}[chunkId] + ".js";
};